/**
 * ProApp.tsx
 * 
 * Shell component for the /pro route.
 * Wires the useEditorCore hook to the new Pro UI components.
 * This file is intentionally small — all business logic lives in useEditorCore.
 */

import React from 'react';
import { useEditorCore } from '../hooks/useEditorCore';
import { ProLayout } from './pro/ProLayout';
import { PasswordGate } from '../components/PasswordGate';
import './pro/pro.css';

export const ProApp: React.FC = () => {
    const editor = useEditorCore({ basePath: '/pro' });

    return (
        <PasswordGate>
            <ProLayout editor={editor} />
        </PasswordGate>
    );
};

export default ProApp;
